import { render, staticRenderFns } from "./TableCell.vue?vue&type=template&id=28baf4b4&scoped=true&"
import script from "./TableCell.vue?vue&type=script&lang=js&"
export * from "./TableCell.vue?vue&type=script&lang=js&"
import style0 from "./TableCell.vue?vue&type=style&index=0&id=28baf4b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28baf4b4",
  null
  
)

export default component.exports